import commonApi from './CommonApi.js';

export default {

    getAll: async (parameters) => {
        return await commonApi().get('/notifications/getAll', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getAutocomplete: async (parameters) => {
        return await commonApi().get('/notifications/getAutocomplete', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },		
	search: async (parameters) => {
		return await commonApi().get('/notifications/search', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
    },
    getYearlyCount: async (parameters) => {
        return await commonApi().get('/notifications/get-yearly-count', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getTopNotifyingParties: async (parameters) => {
        return await commonApi().get('/notifications/get-top-notifying-parties', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    generateReport: async (parameters) => {
        return await commonApi().get('/notifications/generate-report', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getLatestNotifications: async (parameters) => {
        return await commonApi().get('/notifications/get-latest-notifications', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },

    setStatus: async (viewModel) => {
        return await commonApi().post('/notifications/set-status', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },

    getPartiesBySymbols: async (parameters) => {
        return await commonApi().get('/notifications/get-parties-by-symbols', { params: parameters, paramsSerializer: params => { return qs.stringify(params) } })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },

    getDashboard: async (parameters) => {
        return await commonApi().get('/notifications/get-dashboard', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },

}
